// Wait until DOM is loaded
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener('click', function (e) {
      const targetId = this.getAttribute('href');
      if (targetId.length > 1) {
        e.preventDefault();
        const targetElement = document.querySelector(targetId);
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: 'smooth' });
        }
      }
    });
  });

  // document.querySelectorAll('.loop-widget-purchase-option-header').forEach(el => {
  //   const span = document.createElement('span');
  //   span.textContent = '+ FREE gifts';
  //   el.appendChild(span);
  // });
});

// document.addEventListener('DOMContentLoaded', function () {
//   const observer = new MutationObserver((mutationsList, observer) => {
//     const headers = document.querySelectorAll('.loop-widget-purchase-option-header');
//     if (headers.length > 0) {
//       headers.forEach(el => {
//         const span = document.createElement('span');
//         span.textContent = '+ FREE gifts';
//         el.appendChild(span);
//       });
//       observer.disconnect(); // Stop observing once done
//     }
//   });

//   observer.observe(document.body, { childList: true, subtree: true });
// });
document.addEventListener('DOMContentLoaded', function () {
  // Check global free-gifts flag
  const giftsContainer = document.querySelector('.ss-free-gift-products');
  const freeGiftsEnabled = giftsContainer ? giftsContainer.dataset.freeGiftsEnable !== 'false' : true; // default to true if missing

  const observer = new MutationObserver((mutationsList, observer) => {
    const headers = document.querySelectorAll('.loop-widget-purchase-option-header');

    if (headers.length > 0) {
      headers.forEach((el) => {
        // Find the surrounding purchase-option element
        const option = el.closest('.loop-widget-purchase-option');

        // If this is the one-time option AND free gifts are disabled, skip it
        if (option && option.classList.contains('loop-widget-purchase-option-onetime') && !freeGiftsEnabled) {
          return;
        }

        const checkedLabel = document.querySelector(".ss-field-name-quantity input[type='radio']:checked + label");
        let handles = checkedLabel.dataset.giftProductsOnetime
          ? checkedLabel.dataset.giftProductsOnetime.split(',')
          : [];
        if (option.classList.contains('loop-widget-purchase-option-onetime') && !handles.length) return;

        // Otherwise, append the FREE gifts span
        const span = document.createElement('span');
        span.textContent = '+ FREE gifts';
        el.appendChild(span);
      });

      observer.disconnect(); // Stop observing once all headers are processed
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});

// document.addEventListener('click', function(e) {
//   // See if the clicked element (or its parent) has the purchase‐option class
//   const option = e.target.closest('.loop-widget-purchase-option');
//   if (!option) return;

//   console.log('Purchase option clicked');

//   const block = option.closest('.product__info-container');
//   if (!block) return;

//   // const textBelowGift = block.querySelector('.text-below-gift');
//   // if (!textBelowGift) return;
//   const textBelowGift = block.querySelector('.text-below-gift');
//   const freeGiftsEnabledAttr = document.querySelector('.ss-free-gift-products')?.dataset.freeGiftsEnable;
//   const freeGiftsEnabled = freeGiftsEnabledAttr === 'true';

//   // Hide .text-below-gift when one-time is both onetime + selected
//   if (
//     option.classList.contains('loop-widget-purchase-option-onetime') &&
//     option.classList.contains('loop-widget-purchase-option-selected')
//   ) {
//     textBelowGift.style.display = 'none';

//     // Set .ss-percent-off to data-price
//     document.querySelectorAll('.ss-percent-off').forEach((el) => {
//       el.innerText = el.dataset.price;
//     });

//     document.querySelectorAll('.ss-price-bag').forEach((el) => {
//       el.querySelector('strong').innerText = el.dataset.fixPrice;
//     });
//   } else {
//     textBelowGift.style.display = '';

//     // Set .ss-percent-off to data-percentage
//     document.querySelectorAll('.ss-percent-off').forEach((el) => {
//       el.innerText = el.dataset.percentage;
//     });

//     document.querySelectorAll('.ss-price-bag').forEach((el) => {
//       el.querySelector('strong').innerText = el.dataset.flexPrice;
//     });
//   }

//   const selectedOption = document.querySelector('.loop-widget-purchase-option.loop-widget-purchase-option-selected');
//   if (selectedOption) {
//     const priceElement = selectedOption.querySelector('.loop-widget-purchase-option-price');
//     const mainPrice = document.querySelector('.product-form__submit .price__container');

//     if (priceElement && mainPrice) {
//       mainPrice.textContent = priceElement.textContent.trim();
//     }
//   }

//   // Handle gift locking/unlocking logic
//   const freeGiftsInput = document.getElementById('ss-free-gifts-input');

//   if (
//     option.classList.contains('loop-widget-purchase-option-onetime') &&
//     option.classList.contains('loop-widget-purchase-option-selected') &&
//     !freeGiftsEnabled
//   ) {
//     // Lock all gifts and clear input
//     document.querySelectorAll('.ss-free-gift-item').forEach((item) => {
//       const container = item.querySelector('.image-container');
//       if (container) container.classList.add('locked');
//       item.classList.remove('active');
//     });
//     if (freeGiftsInput) freeGiftsInput.value = '';
//   } else {
//     // Unlock eligible gifts based on quantity selection
//     const checkedLabel = document.querySelector(".ss-field-name-quantity input[type='radio']:checked + label");
//     const handles = checkedLabel?.dataset.giftProducts?.split(',') || [];

//     document.querySelectorAll('.ss-free-gift-item').forEach((item) => {
//       const container = item.querySelector('.image-container');
//       const handle = item.dataset.productHandle;
//       const shouldUnlock = handles.includes(handle);

//       if (container) container.classList.toggle('locked', !shouldUnlock);
//       item.classList.toggle('active', shouldUnlock);
//     });

//     const activeTitles = Array.from(document.querySelectorAll('.ss-free-gift-item.active .ss-free-gift-title')).map(
//       (el) => el.textContent.trim()
//     );

//     if (freeGiftsInput) {
//       freeGiftsInput.value = activeTitles.length > 0 ? activeTitles.join(', ') : '';
//     }
//   }

// });
document.addEventListener('click', function (e) {
  // See if the clicked element (or its parent) has the purchase‐option class
  const option = e.target.closest('.loop-widget-purchase-option');
  if (!option) return;

  console.log('Purchase option clicked');

  const block = option.closest('.product__info-container');
  if (!block) return;

  const textBelowGift = block.querySelector('.text-below-gift');
  const freeGiftsEnabledAttr = document.querySelector('.ss-free-gift-products')?.dataset.freeGiftsEnable;
  const freeGiftsEnabled = freeGiftsEnabledAttr === 'true';

  // Handle price and text visibility based on selected option
  if (
    option.classList.contains('loop-widget-purchase-option-onetime') &&
    option.classList.contains('loop-widget-purchase-option-selected')
  ) {
    if (textBelowGift) textBelowGift.style.display = 'none';

    document.querySelectorAll('.ss-percent-off').forEach((el) => {
      el.innerText = el.dataset.price;
    });

    document.querySelectorAll('.ss-price-bag').forEach((el) => {
      el.querySelector('strong').innerText = el.dataset.fixPrice;
    });
  } else {
    if (textBelowGift) textBelowGift.style.display = '';

    document.querySelectorAll('.ss-percent-off').forEach((el) => {
      el.innerText = el.dataset.percentage;
    });

    document.querySelectorAll('.ss-price-bag').forEach((el) => {
      el.querySelector('strong').innerText = el.dataset.flexPrice;
    });
  }

  // Update main price in submit button
  const selectedOption = document.querySelector('.loop-widget-purchase-option.loop-widget-purchase-option-selected');
  if (selectedOption) {
    const priceElement = selectedOption.querySelector('.loop-widget-purchase-option-price');
    const mainPrice = document.querySelector('.product-form__submit .price__container');

    const checkedLabel = document.querySelector(".ss-field-name-quantity input[type='radio']:checked + label");
    const comparePrice = checkedLabel.querySelector('.ss-price-bag').dataset.comparePrice;

    if (priceElement && mainPrice) {
      const price = priceElement.textContent.trim();
      mainPrice.innerHTML = `
      ${price}
      ${comparePrice ? `<span class="ss-compare-price">${comparePrice}</span>` : ''}
    `;

      // mainPrice.textContent = priceElement.textContent.trim();
    }
  }

  // Handle gift locking/unlocking logic
  const freeGiftsInput = document.getElementById('ss-free-gifts-input');

  const oneTimePurchase =
    option.classList.contains('loop-widget-purchase-option-onetime') &&
    option.classList.contains('loop-widget-purchase-option-selected');

  if (oneTimePurchase && !freeGiftsEnabled) {
    // Lock all gifts and clear input
    document.querySelectorAll('.ss-free-gift-item').forEach((item) => {
      const container = item.querySelector('.image-container');
      if (container) container.classList.add('locked');
      item.classList.remove('active');
    });
    if (freeGiftsInput) freeGiftsInput.value = '';
  } else {
    // Unlock eligible gifts based on quantity selection
    const checkedLabel = document.querySelector(".ss-field-name-quantity input[type='radio']:checked + label");
    // const handles = checkedLabel?.dataset.giftProducts?.split(',') || [];

    let handles = checkedLabel.dataset.giftProductsOnetime ? checkedLabel.dataset.giftProductsOnetime.split(',') : [];
    if (oneTimePurchase == false) {
      handles = checkedLabel.dataset.giftProducts ? checkedLabel.dataset.giftProducts.split(',') : [];
    }

    document.querySelectorAll('.ss-free-gift-item').forEach((item) => {
      const container = item.querySelector('.image-container');
      const handle = item.dataset.productHandle;
      const shouldUnlock = handles.includes(handle);

      if (container) container.classList.toggle('locked', !shouldUnlock);
      item.classList.toggle('active', shouldUnlock);
    });

    const activeTitles = Array.from(document.querySelectorAll('.ss-free-gift-item.active .ss-free-gift-title')).map(
      (el) => el.textContent.trim(),
    );

    if (freeGiftsInput) {
      freeGiftsInput.value = activeTitles.length > 0 ? activeTitles.join(', ') : '';
    }
  }
});

document.addEventListener('DOMContentLoaded', function () {
  // For each .product__info-container on the page:
  document.querySelectorAll('.product__info-container').forEach(function (block) {
    const priceContainer = block.querySelector('.product-form__submit .price__container');
    if (!priceContainer) return;

    // Helper: find the currently selected option's price, if available
    function updatePriceIfSelectedExists() {
      const selectedOption = block.querySelector('.loop-widget-purchase-option.loop-widget-purchase-option-selected');
      if (!selectedOption) return false;

      const priceElem = selectedOption.querySelector('.loop-widget-purchase-option-price');
      if (!priceElem) return false;

      const checkedLabel = document.querySelector(".ss-field-name-quantity input[type='radio']:checked + label");
      const comparePrice = checkedLabel.querySelector('.ss-price-bag').dataset.comparePrice;

      const price = priceElem.textContent;
      priceContainer.innerHTML = `
        ${price}
        ${comparePrice ? `<span class="ss-compare-price">${comparePrice}</span>` : ''}
      `;

      // priceContainer.textContent = priceElem.textContent;
      return true;
    }

    // 1) Try immediately in case the class is already there
    if (updatePriceIfSelectedExists()) {
      return; // done for this block
    }

    // 2) If not found yet, observe mutations under this block
    const observer = new MutationObserver(function (mutations, obs) {
      if (updatePriceIfSelectedExists()) {
        obs.disconnect();
      }
    });

    observer.observe(block, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });
  });
});

document.addEventListener('loop.variant.change', (event) => {
  // Your custom logic here
  console.log('Variant changed:', event.detail);
});
